import './LoggedUser.scss';
import { Button } from 'react-bootstrap';
import { PersonFill as UserIcon } from 'react-bootstrap-icons';
import { languageElements } from './LoggedUser-languageElements';
import LanguageElementsHandler from '../../repository/languageElementsHandler/LanguageElementsHandler';
import useMain from '../../common/MainContext';

export default function LoggedUser(props) {
  const { loginData, language, logout } = useMain();

  const languageElementsHandler = new LanguageElementsHandler(
    languageElements,
    language
  );

  return (
    <div className='logged-user'>
      <Button className='logged-user-button' variant='success' onClick={logout} >
        <UserIcon width={32} height={32} />
        {languageElementsHandler.get("div-LoggedUser")}
        <span>{loginData?.get().user.email}</span>
      </Button>
    </div>
  );
}
